(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-aura-video-open]');
  if (trigger) {
    const dialog = trigger.closest('.aura-page').querySelector('.aura-video-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    dialog.querySelector('iframe').src = dialog.querySelector('iframe').dataset.src;
    dialog.addEventListener('close', () => { dialog.querySelector('iframe').removeAttribute('src'); trigger.focus(); }, { once: true });
    dialog.showModal();
  }
  if (event.target.matches('.aura-video-dialog')) {
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-v2-effects"] && !Shopify.designMode) return;
  try {
    
function prepareAuraMedia(root) {
 root.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.decode().catch(() => {}); });
 root.querySelectorAll('video').forEach(video => {
  if (video.dataset.prepared) return;
  video.dataset.prepared = 'true'; video.preload = 'auto';
  if (!video.getAttribute('src')) video.src = video.dataset.src;
  video.load();
 });
}
function playAuraPreview(root, manual = false) {
 const video = root.querySelector('video:not([hidden])');
 if (!video || document.hidden || (!manual && (root.dataset.userPaused === 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches))) return;
 prepareAuraMedia(root);
 video.muted = true;
 video.play().catch(error => {
  if (!['AbortError', 'NotAllowedError'].includes(error.name)) root.querySelector('[data-aura-video-error]').hidden = false;
 });
}
function enableAuraPreviews() {
 document.querySelectorAll('[data-aura-effects] .aura-effect-controls, [data-aura-effects] [data-aura-effect-play]').forEach(control => control.hidden = false);
 const roots = document.querySelectorAll('[data-aura-effects], .aura-adaptive-scenes');
 if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
   if (entry.isIntersecting) { prepareAuraMedia(entry.target); observer.unobserve(entry.target); }
  }), {rootMargin:'800px'});
  roots.forEach(root => observer.observe(root));
  const pauseObserver = new IntersectionObserver(entries => entries.forEach(entry => {
   entry.target.dataset.inView = String(entry.isIntersecting);
   if (entry.isIntersecting) playAuraPreview(entry.target); else entry.target.querySelectorAll('video').forEach(video => video.pause());
  }));
  document.querySelectorAll('[data-aura-effects]').forEach(root => pauseObserver.observe(root));
 } else { roots.forEach(prepareAuraMedia); document.querySelectorAll('[data-aura-effects]').forEach(root => { root.dataset.inView = 'true'; playAuraPreview(root); }); }
 if (matchMedia('(prefers-reduced-motion: reduce)').matches) document.querySelectorAll('[data-aura-effects] video').forEach(video => video.loop = false);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enableAuraPreviews); else enableAuraPreviews();
document.addEventListener('shopify:section:load', enableAuraPreviews);
function updateAuraPlayback(event) {
 const video = event.target;
 if (!video.matches('[data-aura-effects] video') || video.hidden) return;
 const play = video.closest('[data-aura-effects]').querySelector('[data-aura-effect-play]');
 play.querySelector('[data-aura-play-label]').textContent = video.paused ? play.dataset.playLabel : play.dataset.pauseLabel;
 play.querySelector('[aria-hidden]').textContent = video.paused ? '▶' : 'Ⅱ';
}
['play','pause','ended'].forEach(name => document.addEventListener(name, updateAuraPlayback, true));
document.addEventListener('click', event => {
 const effect = event.target.closest('[data-aura-effect]');
 if (effect) {
  const root = effect.closest('[data-aura-effects]'), play = root.querySelector('[data-aura-effect-play]');
  prepareAuraMedia(root);
  root.querySelectorAll('video').forEach(video => { video.pause(); video.hidden = video.dataset.effectId !== effect.dataset.effectId; });
  root.querySelectorAll('[data-aura-effect]').forEach(button => button.setAttribute('aria-pressed', String(button === effect)));
  play.dataset.placement = effect.textContent.trim();
  play.querySelector('[data-aura-play-label]').textContent = play.dataset.playLabel;
  play.querySelector('[aria-hidden]').textContent = '▶';
  root.querySelector('[data-aura-flashing]').hidden = effect.dataset.flashing !== 'true';
  root.querySelector('[data-aura-video-error]').hidden = true;
  root.dataset.userPaused = 'false';
  playAuraPreview(root);
 }
 const play = event.target.closest('[data-aura-effect-play]');
 if (play) {
  const root = play.closest('[data-aura-effects]'), video = root.querySelector('video:not([hidden])');
  root.dataset.userPaused = String(!video.paused);
  if (video.paused) playAuraPreview(root, true); else video.pause();
 }

});
document.addEventListener('visibilitychange', () => {
 document.querySelectorAll('[data-aura-effects]').forEach(root => {
  if (document.hidden) root.querySelectorAll('video').forEach(video => video.pause());
  else if (root.dataset.inView === 'true') playAuraPreview(root);
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-v2-hero"] && !Shopify.designMode) return;
  try {
    
const auraVideoDialog = document.querySelector('[data-aura-video-dialog]');
const auraVideo = auraVideoDialog?.querySelector('iframe');
document.querySelector('[data-aura-video-open]')?.addEventListener('click', () => { auraVideoDialog.showModal(); auraVideo.src = auraVideo.dataset.src; });
document.querySelector('[data-aura-video-close]')?.addEventListener('click', () => auraVideoDialog.close());
auraVideoDialog?.addEventListener('close', () => { auraVideo.removeAttribute('src'); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-v2-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const summary = event.target.closest('.aura-product-nav summary');
  if (summary) summary.closest('details').dataset.auraScrollY = window.scrollY;
}, true);
document.addEventListener('toggle', event => {
  if (event.target.matches('.aura-product-nav details') && event.target.open) {
    const y = Number(event.target.dataset.auraScrollY || window.scrollY);
    requestAnimationFrame(() => window.scrollTo(0, y));
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-v2-room"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aura-room-glow')) {
  customElements.define('aura-room-glow', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.colors = [...this.querySelectorAll('[data-glow-color]')];
      this.play = this.querySelector('[data-glow-play]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.inView = false;
      this.focused = false;
      this.index = Math.max(0, this.colors.findIndex(button => button.dataset.glowColor === this.dataset.color));
      this.querySelector('.aura-glow-controls').hidden = false;
      this.colors.forEach((button, index) => button.addEventListener('click', () => {
        this.paused = true;
        this.select(index);
        this.schedule();
      }, options));
      this.play.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = this.colors.includes(document.activeElement); this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.schedule();
    }
    select(index) {
      this.index = index;
      this.dataset.color = this.colors[index].dataset.glowColor;
      this.colors.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
    }
    schedule() {
      clearTimeout(this.timer);
      this.play.textContent = this.paused ? this.play.dataset.playLabel : this.play.dataset.pauseLabel;
      if (this.paused || !this.inView || this.focused || document.hidden) return;
      this.timer = setTimeout(() => {
        this.select((this.index + 1) % this.colors.length);
        this.schedule();
      }, 2800);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer.disconnect();
      this.abort.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caura-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const summary = event.target.closest('.caura-product-nav summary');
  if (summary) summary.closest('details').dataset.auraScrollY = window.scrollY;
}, true);
document.addEventListener('toggle', event => {
  if (event.target.matches('.caura-product-nav details') && event.target.open) {
    const y = Number(event.target.dataset.auraScrollY || window.scrollY);
    requestAnimationFrame(() => window.scrollTo(0, y));
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caura-scenes"] && !Shopify.designMode) return;
  try {
    
function initCauraCycles(root) {
  root.querySelectorAll('[data-auto-cycle]').forEach(switcher => {
    if (switcher.dataset.cycleReady) return;
    switcher.dataset.cycleReady = 'true';
    const radios = [...switcher.querySelectorAll('input[type="radio"]')];
    const button = switcher.querySelector('.caura-cycle-toggle');
    const frames = switcher.querySelector('.caura-scene-frames');
    if (radios.length < 2 || !button) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const options = { signal: events.signal };
    let paused = motion.matches;
    let visible = false;
    let hovering = false;
    function updateButton() {
      button.hidden = false;
      button.textContent = paused ? button.dataset.play : button.dataset.pause;
    }
    function pause() { paused = true; updateButton(); }
    updateButton();
    button.addEventListener('click', () => { paused = !paused; updateButton(); }, options);
    switcher.addEventListener('change', pause, options);
    switcher.addEventListener('focusin', event => {
      if (event.target.matches('input')) pause();
    }, options);
    frames.addEventListener('pointerenter', event => { hovering = event.pointerType === 'mouse'; }, options);
    frames.addEventListener('pointerleave', () => { hovering = false; }, options);
    motion.addEventListener('change', () => { if (motion.matches) pause(); }, options);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
    }, { threshold: 0.2 });
    observer.observe(frames);
    const timer = setInterval(() => {
      if (paused || hovering || !visible || document.hidden) return;
      const next = (radios.findIndex(radio => radio.checked) + 1) % radios.length;
      const image = frames.querySelectorAll('figure img')[next];
      if (image && (!image.complete || !image.naturalWidth)) return;
      radios[next].checked = true;
    }, 2000);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(switcher)) return;
      clearInterval(timer);
      observer.disconnect();
      events.abort();
    }, options);
  });
}
initCauraCycles(document);
document.addEventListener('shopify:section:load', event => initCauraCycles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpro-hero"]) return;
  try {
    
document.addEventListener('click', event => {
  const summary = event.target.closest('.cp-product-nav summary');
  if (summary) summary.closest('details').dataset.scrollY = String(window.scrollY);
}, true);
document.addEventListener('toggle', event => {
  if (!event.target.matches('.cp-product-nav details')) return;
  const savedY = event.target.dataset.scrollY;
  delete event.target.dataset.scrollY;
  if (savedY === undefined) return;
  const y = Number(savedY);
  if (Number.isFinite(y)) requestAnimationFrame(() => window.scrollTo({top:y,behavior:'instant'}));
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpro-resources"] && !Shopify.designMode) return;
  try {
    
function openCProSpecifications(){if(location.hash==='#tech-specs'){const panel=document.getElementById('tech-specs');if(panel){panel.open=true;document.getElementById('resources').scrollIntoView({block:'start'});}}}
window.addEventListener('hashchange',openCProSpecifications);
openCProSpecifications();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intecular-header"]) return;
  try {
    
document.addEventListener('click', event => {
  for (const menu of document.querySelectorAll('.ic-site-menu[open]')) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  }
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.ic-site-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intecular-home-story"] && !Shopify.designMode) return;
  try {
    
const toneObserver = new IntersectionObserver((entries, observer) => {
  for (const entry of entries) {
    if (!entry.isIntersecting) continue;
    for (const image of entry.target.querySelectorAll('.ih-tone-panel img')) image.loading = 'eager';
    observer.unobserve(entry.target);
  }
}, { rootMargin: '400px' });
for (const tones of document.querySelectorAll('.ih-tones')) toneObserver.observe(tones);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["invisoutlet-c-aura-landing"] && !Shopify.designMode) return;
  try {
    
const root = document.querySelector('[data-c-aura]');
if (root) {
  const panel = root.querySelector('[data-scene-panel]');
  root.querySelectorAll('[data-scene]').forEach((button) => button.addEventListener('click', () => {
    const colors = { warm: '#edaa63', rose: '#e783a5', violet: '#9d68d3', teal: '#55b8b0' };
    panel.style.setProperty('--scene-color', colors[button.dataset.scene]);
    root.querySelectorAll('[data-scene]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
  }));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-landing-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', event => {
  if (event.target.matches('.pro-product-nav details') && event.target.open) {
    event.target.closest('.pro-product-nav').scrollIntoView({block:'start',behavior:'instant'});
  }
}, true);
const proVideoDialog = document.querySelector('[data-pro-video-dialog]');
const proVideo = proVideoDialog?.querySelector('iframe');
document.querySelector('[data-pro-video-open]')?.addEventListener('click', () => { proVideoDialog.showModal(); proVideo.src = proVideo.dataset.src; });
document.querySelector('[data-pro-video-close]')?.addEventListener('click', () => proVideoDialog.close());
proVideoDialog?.addEventListener('close', () => { proVideo.removeAttribute('src'); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-landing-resources"] && !Shopify.designMode) return;
  try {
    
function openProSpecifications(){if(location.hash==='#tech-specs'){const panel=document.getElementById('tech-specs');if(panel){panel.open=true;document.getElementById('resources').scrollIntoView({block:'start'});}}}
window.addEventListener('hashchange',openProSpecifications);
openProSpecifications();

  } catch(e) { console.error(e); }
})();
})();
